<template>
  <div id="altnames">
    <div class="container-fluid">
      <div class="row">
        <div
          role="main"
          class="col d-block pt-2"
        >
          <section class="pt-3">
            <div class="section-title">
              Alt Location Names
            </div>
            <div class="row d-block">
              <div class="col">
                <div class="row mt-3">
                  <div class="col-12 col-xl-6">
                    <h5>Top (up to {{ top }}) unmapped texts from recent imports</h5>
                    <table class="table table-striped table-sm">
                      <thead>
                        <tr>
                          <th scope="col">
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Text Filter"
                              v-model="searchUnmappedText"
                              @input="filterUnmapped"
                            >
                          </th>
                          <th scope="col">
                            Occurrences
                          </th>
                          <th scope="col" />
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="unmapped in filteredUnmapped"
                          :key="unmapped.loc"
                        >
                          <td>{{ unmapped.loc }}<br>
                            <sub>e.g user input: {{ unmapped.province }}->{{ unmapped.town }}-><strong>{{ unmapped.loc }}</strong></sub>
                            <sub
                              v-for="added in findRecentMappings(unmapped.loc)"
                              :key="added.id"
                              style="color: red; clear: both;"
                            >
                              <br>
                              added {{ daysAgo(added.createdAt) }} for {{ added.displayName }} ({{ added.locationId }})
                            </sub>
                          </td>
                          <td>{{ unmapped.count }}</td>
                          <td>
                            <button
                              class="btn btn-link p-0 btn-sm"
                              @click="addMapping( unmapped )"
                            >
                              Add Mapping
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="col-12 col-xl-6">
                    <h5 class="d-flex align-items-center justify-content-between">
                      Existing Alt Location Names
                      <button
                        type="button"
                        class="btn btn-outline-primary btn-sm"
                        @click="modeNewMapping = true"
                      >
                        Add Alt Location name
                      </button>
                    </h5>
                    <table class="table table-striped table-sm">
                      <thead>
                        <tr>
                          <th scope="col">
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Text Filter"
                              v-model="searchMappingText"
                              @input="filterMappings"
                            >
                          </th>
                          <th scope="col">
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Code Filter"
                              v-model="searchMappingCode"
                              @input="filterMappings"
                            >
                          </th>
                          <th scope="col" />
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="mapping in filteredMappings"
                          :key="mapping.id"
                        >
                          <td>{{ mapping.name }}</td>
                          <td>{{ mapping.displayName }} ({{ mapping.locationId }})</td>
                          <td>
                            <button
                              class="btn btn-link p-0 btn-sm"
                              @click="removeMapping(mapping.id)"
                            >
                              Remove
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div class="clearfix" />
        </div>
        <div class="clearfix" />
      </div>
    </div>
    <div
      id="newMapping"
      :class="`modal fade px-0 ${ modeNewMapping ? 'show d-block' : 'd-none'}`"
      tabindex="-1"
      role="dialog"
    >
      <div
        class="modal-dialog"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              Add new alt name
            </h5>
            <button
              type="button"
              class="close"
              @click="closeAddNewMapping"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body container-fluid">
            <form @submit.prevent="addNewMapping">
              <div class="form-group">
                <label for="key">For text</label>
                <input
                  type="attribute"
                  class="form-control"
                  v-model="newMappingText"
                  placeholder="Mapping Text"
                  required
                >
              </div>
              <div class="form-group">
                <label for="key">Resolve to</label>
                <vue-typeahead-bootstrap
                  placeholder="Start typing a location name..."
                  v-model="query"
                  @hit="selectedLocation = $event"
                  :min-matching-chars="2"
                  :data="locations"
                  :serializer="item => item.displayName + ' (' + item.id + ' ' + item.type + ')'"
                  :disable-sort="true"
                  :show-all-results="true"
                  required
                />
              </div>
              <button
                class="btn btn-primary btn-block mt-2"
                type="submit"
                :disabled="isAddNewMappingFormInSubmission"
              >
                Add
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { assertLiteral } from 'babel-types';
import http from '../../../http';
import notify from '../../../notifications';

export default {
    data() {
        return {
            top: 1000,
            searchUnmappedText: '',
            searchMappingText: '',
            searchMappingCode: '',
            query: '',
            isAddNewMappingFormInSubmission: false,
            newMappingText: '',
            modeNewMapping: false,
            allMappings: [],
            filteredMappings: [],
            filteredUnmapped: [],
            allUnmapped: [],
            locations: [],
            selectedLocation: null
        };
    },
    watch: {
        query( q ) {
            this.loadLocations( q );
        }
    },
    methods: {
        daysAgo( since ) {
            let sinceDate = Date.parse( since );
            let now = Date.now();
            const msInADay = 1000 * 60 * 60 * 24;
            let daysAgo = Math.floor( ( now - sinceDate ) / msInADay );

            if ( daysAgo <= 1 ) {
                return 'less than a day ago';
            }

            return daysAgo + ' days ago ';
        },
        addMapping( mapping ) {
            this.modeNewMapping = true;
            this.newMappingText = mapping.loc;
            this.selectedLocation = null;
            this.query = '';
        },
        closeAddNewMapping() {
            this.modeNewMapping = false;
            this.newMappingText = '';
            this.selectedLocation = null;
            this.query = '';
        },
        findRecentMappings( loc ) {
            if ( !loc ) {
                return [];
            }

            return this.allMappings.filter( f => f.name == loc );
        },
        filterMappings() {
            let filtered = this.allMappings;

            if ( this.searchMappingText.length > 0 ) {
                filtered = filtered.filter( f => f.name.toLowerCase().includes( this.searchMappingText.toLowerCase() ) );
            }

            if ( this.searchMappingCode.length > 0 ) {
                filtered = filtered.filter( f => ( `${f.displayName} (${f.locationId})`.toLowerCase()  ).includes( this.searchMappingCode.toLowerCase() ) );
            }

            this.filteredMappings = filtered;
        },
        filterUnmapped() {
            let filtered = this.allUnmapped;

            if ( this.searchUnmappedText.length > 0 ) {
                filtered = filtered.filter( f => f.loc.toLowerCase().includes( this.searchUnmappedText.toLowerCase() ) );
            }

            this.filteredUnmapped = filtered;
        },
        async getUnmapped() {
            const response = await http.get( '/locationmapping/topunmapped?top=' + this.top );

            if ( response.status === 200 ) {
                this.allUnmapped = await response.json();
            } else {
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to load unmapped'
                } );
            }
        },
        async getMappings() {
            const response = await http.get( '/locationmapping' );

            if ( response.status === 200 ) {
                this.allMappings = await response.json();
            } else {
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to get mappings'
                } );
            }
        },
        async removeMapping( mappingId ) {
            this.$store.dispatch( 'appLoading', true );
            const response = await http.delete( '/locationmapping/' + mappingId );

            if ( response.status === 200 ) {
                await this.loadMappings();
            } else {
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to remove mapping'
                } );
            }
            this.$store.dispatch( 'appLoading', false );
        },
        async addNewMapping() {
            if ( this.selectedLocation == null ) {
                notify( {
                    type: 'error',
                    text: 'No location selection',
                    title: 'Please select location'
                } );
                return;
            }

            this.isAddNewMappingFormInSubmission = true;

            this.$store.dispatch( 'appLoading', true );

            let data = {
                name: this.newMappingText,
                locationId: this.selectedLocation.id
            };

            const response = await http.post( '/locationmapping', data );

            if ( response.status !== 200 ) {
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to add new mapping'
                } );
            }

            this.closeAddNewMapping();
            await this.loadMappings();

            this.isAddNewMappingFormInSubmission = false;
            this.$store.dispatch( 'appLoading', false );
        },
        async loadMappings() {
            await Promise.all( [
                this.getMappings(),
                this.getUnmapped()
            ] );

            this.filterMappings();
            this.filterUnmapped();
        },
        async loadLocations( q ) {
            if ( !q || q.length < 2 ) {
                this.locations = [];
                return;
            }

            const response = await http.get( '/locationsuggestion?q=' + q );
            if ( response.status !== 200 ) {
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to load locations'
                } );
            } else {
                this.locations = await response.json();
            }
        }
    },
    async mounted() {
        this.$store.dispatch( 'appLoading', true );

        await Promise.all( [
            this.loadMappings()
        ] );

        this.$store.dispatch( 'appLoading', false );
        document.title = 'thinkSPAIN - Alt Location Names';
    }
};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/altnames/index.vue